<template>
  <!-- 左边菜单 -->
  <el-aside class="aside" :width="aside + 'px'">
    <Row style="height: 100%">
      <Col span="2">
      <Menu :theme="theme" style="width: 200px; height: 100%" :style="'background:' + LeftBackground" accordion>
        <MenuItem name="1" @click="routers('/content/statistics')">
        <Icon type="ios-stats" />
        溯源统计
        </MenuItem>
        <MenuItem name="2" @click="routers('/content/Code')" v-if="$store.state.control == 1 || $store.state.sy_control">
        <Icon type="ios-albums" />
        溯源码库
        </MenuItem>
        <Submenu :style="'background:' + LeftBackground" name="3" v-if="$store.state.control == 1" @click="sideOn(true)">
          <template #title>
            <Icon type="ios-people" />
            客户管理
          </template>
          <MenuItem name="3-1" @click="routers('/content/CompanyInfromation')">企业信息管理</MenuItem>
          <MenuItem name="3-2" @click="routers('/content/RowCode')">码库管理</MenuItem>
        </Submenu>

        <Submenu :style="'background:' + LeftBackground" name="4"
          v-if="$store.state.control == 1 || $store.state.wl_control" @click="sideOn(true)">
          <template #title>
            <Icon type="md-filing" />
            产品管理
          </template>
          <MenuItem name="4-1" @click="routers('/content/product')">产品列表</MenuItem>
          <MenuItem name="4-2" @click="routers('/content/productCustom')">产品自定义字段</MenuItem>
        </Submenu>

        <Submenu :style="'background:' + LeftBackground" name="5"
          v-if="$store.state.control == 1 || $store.state.sy_control" @click="sideOn(true)">
          <template #title>
            <Icon type="ios-paper" />
            溯源管理
          </template>
          <MenuItem name="5-1" @click="routers('/content/filedList')">溯源信息设定</MenuItem>
          <MenuItem name="5-2" @click="routers('/content/AssignList')">溯源字段设定</MenuItem>
        </Submenu>

        <Submenu :style="'background:' + LeftBackground" name="6"
          v-if="$store.state.control == 1 || $store.state.fw_control" @click="sideOn(true)">
          <template #title>
            <Icon type="ios-time" />
            防伪管理
          </template>
          <MenuItem name="6-1" v-if="$store.state.control == 1" @click="routers('/content/ResultList')">防伪回复信息</MenuItem>
          <MenuItem name="6-2" @click="routers('/content/ResultAll')">默认回复信息</MenuItem>
          <MenuItem name="6-3" @click="routers('/content/ScanRecord')">扫码记录查询</MenuItem>
        </Submenu>

        <MenuItem name="7" @click="routers('/content/feedback')">
        <Icon type="md-flag" />
        消费者反馈
        </MenuItem>
      </Menu>
      </Col>
    </Row>
  </el-aside>
  <!-- 内容 -->
  <el-main class="main">
    <router-view></router-view>
  </el-main>
</template>

<script>
export default {
  data() {
    return {
      value: true, //侧边栏
      aside: 200, //侧边栏宽度
      control: 0,
      theme: "",
      LeftBackground: "",
    };
  },
  computed: {
    asides() {
      return this.$store.state.switch;
    },
  },
  mounted() {
    // 获取主题
    this.theme = this.$store.state.theme;
    // 获取主题背景颜色
    this.LeftBackground = this.$store.state.LeftBackgroundColor;
  },
  watch: {
    // 监听侧边栏开关的值设置侧边栏宽度
    asides(newVal, oldVal) {
      if (newVal) {
        this.aside = 200;
      } else {
        this.aside = 45;
      }
    },
  },
  methods: {
    // 路由跳转
    routers(val) {
      this.sideOn(true);
      this.$router.push(val);
    },
    // 侧边栏开关
    sideOn(a) {
      if (a == null) {
        this.value = !this.value;
      } else {
        this.value = a;
      }
    },
  },
};
</script>

<style scoped>
@import url("//unpkg.com/element-ui@2.15.6/lib/theme-chalk/index.css");

.aside {
  background: white;
  transition: all 0.3s;
  border-top: 1px solid #111;
  z-index: 1000;
  overflow: hidden;
  padding: 0%;
}

.aside .menu {
  width: 200px;
  border-right: 0;
  padding-right: 0;
}

.aside .menu>.menu-v {
  border-right: 0;
}
</style>
